<template>
  <div class="view-evInfo container">
    <div class="floor-breadcrumb">
      <el-breadcrumb class="hsb-breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="reEvURI">机况评估</el-breadcrumb-item>
        <el-breadcrumb-item>获得报价</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <FloorSelect></FloorSelect>
    <FloorEvaluateResult></FloorEvaluateResult>
    <FloorHelp></FloorHelp>
  </div>
</template>

<script>
import evStore from '@/core/ev-info/store';
import FloorHelp from './floor-help';
import FloorSelect from './floor-select';
import { Breadcrumb, BreadcrumbItem } from 'element-ui';
import FloorEvaluateResult from './floor-evaluate-result';

export default {
  asyncData ({ store, route }) {
    return store.dispatch('evaluate/getEvInfo', route.params.evID);
  },
  registerModule (store, preserveState) {
    store.registerModule('evaluate', evStore, { preserveState });
  },
  destroyed () {
    this.$store.unregisterModule('evaluate');
  },
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    FloorSelect,
    FloorEvaluateResult,
    FloorHelp
  },
  computed: {
    evInfo () {
      return this.$store.state.evaluate.info || {};
    },
    evaluateid () {
      return this.$route.params.evID;
    },
    activeInfo () {
      return (this.evInfo.activityList && this.evInfo.activityList[0]) || {};
    },
    reEvURI () {
      return `/evaluate/${this.evInfo.productId}.html?selecteds=${this.$route.query.selecteds}`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/evInfo/index.vue